import { z } from "zod";

export const ResetPasswordSchema = z.object({
  password: z.string().min(5, "Password need to be more than 5 chars"),
});

export type IResetPassword = z.infer<typeof ResetPasswordSchema>;
